import { defineMessages } from 'react-intl';

export const messages: {
	automationRuleIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	automationRuleIconLabel: {
		id: 'studio-trigger-solution-build-plan-card.title-icon-picker.automation-rule-icon-label',
		defaultMessage: 'Automation Rule',
		description: 'Automation Rule icon label (displayed in the card)',
	},
});
